/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadCoverPhotoResponseDto
 */
export interface UploadCoverPhotoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadCoverPhotoResponseDto
     */
    url: string;
}

/**
 * Check if a given object implements the UploadCoverPhotoResponseDto interface.
 */
export function instanceOfUploadCoverPhotoResponseDto(value: object): value is UploadCoverPhotoResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UploadCoverPhotoResponseDtoFromJSON(json: any): UploadCoverPhotoResponseDto {
    return UploadCoverPhotoResponseDtoFromJSONTyped(json, false);
}

export function UploadCoverPhotoResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadCoverPhotoResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function UploadCoverPhotoResponseDtoToJSON(json: any): UploadCoverPhotoResponseDto {
    return UploadCoverPhotoResponseDtoToJSONTyped(json, false);
}

export function UploadCoverPhotoResponseDtoToJSONTyped(value?: UploadCoverPhotoResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

